import { Button } from "@/components/ui/button";
import type { HomeRecord } from "./record";

/** Dev only: puts the record back to a fresh account's. */
export function ResetControl({ record }: { record: HomeRecord }) {
  return (
    <div className="flex justify-end">
      <Button
        variant="ghost"
        size="sm"
        className="text-muted-foreground"
        onClick={() => void record.reset()}
      >
        Reset onboarding
      </Button>
    </div>
  );
}
